module.exports = __webpack_public_path__ + "static/media/brain.527d3edb.svg";